import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import {
  verifyPhoneNumber,
  changePhoneNumber,
  koalaAnalyticsActions,
} from 'actions';
import VerifyPhoneFormComponent from 'components/PhoneForm/VerifyPhoneFormComponent';
import { forms } from 'constants';
import { trimWhiteSpace } from 'utils/validation';

const validate = values => {
  const errors = {};
  if (!trimWhiteSpace(values.VerificationCode)) {
    errors.VerificationCode = 'Please enter your SMS code.';
  }
  return errors;
};

const VerifyPhoneFormContainer = reduxForm({
  form: forms.VerifyPhone,
  validate,
})(VerifyPhoneFormComponent);

const mapStateToProps = state => ({
  initialValues: {
    PhoneNumber: state.app.verifyPhone.phoneNumber,
  },
  verifyPhone: state.app.verifyPhone,
  status: {
    ...state.app.appErrors,
  },
});

export const mapDispatchToProps = dispatch => ({
  submitHandler: (values, push) =>
    dispatch(verifyPhoneNumber({ values, push })),
  resendCode: PhoneNumber => {
    dispatch(changePhoneNumber({ PhoneNumber }, true));
  },
  trackPageView: (subtype, pageSection) => {
    koalaAnalyticsActions.trackPageView(subtype, pageSection)(dispatch);
  },
  trackLinkClick: (subtype, pageSection, eventValue) => {
    koalaAnalyticsActions.trackLinkClick(
      subtype,
      pageSection,
      eventValue,
    )(dispatch);
  },
});
const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withRouter(VerifyPhoneFormContainer));
